// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OVDy","selected":"styles_selected__4Acci"};